import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * PR Manager - Dahili İzleme (Monitoring) Servisi
 * Sentry benzeri bir mekanizma ile hataları veritabanına kaydeder.
 */
class MonitoringService {
  constructor() {
    this.logsCollection = 'system_logs';
    this.isProduction = process.env.NODE_ENV === 'production';
  }

  /**
   * Hatayı Firestore'a kaydet
   * @param {Error} error - Hata nesnesi
   * @param {Object} context - Ekstra bağlam (bileşen adı, kullanıcı ID vb.)
   */
  async logError(error, context = {}) {
    try {
      // Geliştirme ortamında konsola da yaz
      if (!this.isProduction) {
        console.error(' [Monitoring] Hata yakalandı:', error, context);
      }

      const logData = {
        type: 'error',
        message: error.message || 'Bilinmeyen Hata',
        stack: error.stack || null,
        context: {
          ...context,
          url: window.location.href,
          userAgent: navigator.userAgent,
          platform: navigator.platform
        },
        timestamp: serverTimestamp(),
        level: context.level || 'error' // error, warning, info
      };

      // Firestore'a kaydet
      const docRef = await addDoc(collection(db, this.logsCollection), logData);
      
      if (!this.isProduction) {
        console.log(' [Monitoring] Hata veritabanına kaydedildi:', docRef.id);
      }

      return docRef.id;
    } catch (logErr) {
      // Loglama başarısız olursa (örn: internet yok), en azından konsola bas (fail-safe)
      console.error(' [Monitoring] Hata loglanamadı:', logErr);
      return null;
    }
  }

  /**
   * Bilgi veya uyarı logla
   */
  async logInfo(message, context = {}, level = 'info') {
    if (this.isProduction && level === 'info') return; // Production'da info loglama (isteğe bağlı)

    try {
      await addDoc(collection(db, this.logsCollection), {
        type: level,
        message,
        context,
        timestamp: serverTimestamp()
      });
    } catch (e) {
      // Sessiz hata
    }
  }
}

const monitoringService = new MonitoringService();
export default monitoringService;
